import { FigureCompositionEditor } from '@/components/figure-composition/FigureCompositionEditor';

export default function FigureCompositionDevPage() {
  return (
    <div className="w-screen h-screen">
      <FigureCompositionEditor projectId="dev-project" />
    </div>
  );
}










